/*!
 * Filename : App.tsx
 * Author: Achmad Yusri Afandi (yusrideb@cpan.org)
 * Date Create : 8/19/26 9:14 PM
 */

import React from "react";

import Login from "./Form/Login";

import styles from "./styles/login.module.scss";

export default (props) => {
  const dataPage = typeof window !== "undefined" && Object.prototype.hasOwnProperty.call(window, "data_login")
    ? (window as any).data_login
    : {};
  const loginBg = dataPage?.img?.login_bg || "bg/apps.webp";
  const bgUrl = loginBg.startsWith("/") ? loginBg : "/content/" + loginBg;

  return (
    <div className={["content", styles.loginPage].join(" ")}>
      <div className={["overlay", styles.overlay].join(" ")} />
      <div className={styles.background} style={{backgroundImage: `url(${bgUrl})`}} />
      <Login dataPage={dataPage} />
      <footer className={styles.footer}>
        <div className={styles.copyright} style={{backgroundImage: "url(/content/bg/dark-mosaic.webp)"}}>
          <span>{"© 2026 - " + (dataPage["app_name"] ?? "FinFlow") + "."}</span>
        </div>
      </footer>
    </div>
  );
};
